export default "__VITE_ASSET__CA93R_Tp__"